import HTTP from '@/plugins/axios';

export interface Academic {
  applicant_count: number
  isco_code: string
  isco_name: string
  skill_level: number
}

export interface ProfessionGroups {
  'non-academic': Academic[]
  academic: Academic[]
}
export interface WorkersGroupResponse {
  profession_groups: ProfessionGroups
}

export type Applicant = {
  id: number
  position: string
  position_keywords: string
  locations: string
  professions: string
  availability: string
}

export type Params = {
  sid: string
  'isco[]': string[]
  sort: string
  limit: string
  NumRows: string
  total_rows: number
  page: number
}

type WorkersListResponse = {
  applicants: Applicant[]
  params: Params
}

export type SearchBlockRow = {
  name: string
  value: string
  type: string
  count: number
}

export type SearchBlock = {
  name: string
  block_type: string
  rows: SearchBlockRow[]
}

export type SearchLanguage = {
  language_id: number
  language_name: string
}

export type LanguageOption = {
  value: number
  name: string
}

export type SalaryOption = {
  name: string
  id: number
}

export type LocationOption = {
  location_id: string
  location_name: string
}

export type ClustersOption = {
  applicants_count: number
  cluster_id: number
  cluster_name: string
  picture: string
}

export type WorkersFilterSettingsResponse = {
  search_blocks: SearchBlock[]
  search_languages: SearchLanguage[]
  language_options: LanguageOption[]
  salary_options: SalaryOption[]
  location_options: LocationOption[]
  clusters: ClustersOption[]
  overall_applicants_count: number
}

export const getWorkersGroups = async(params: any): Promise<WorkersGroupResponse> => {
  const response = await HTTP.get('/jobnews/applicant_isco_groups', {
    params,
  });
  return response.data;
};

export const getWorkersList = async(params: any): Promise<WorkersListResponse> => {
  const response = await HTTP.get('/jobnews/applicant_list', {
    params,
  });
  return response.data;
};

export const getWorkersFiltersSettings = async(params: any): Promise<WorkersFilterSettingsResponse> => {
  const response = await HTTP.get('/jobnews/applicant_search_data', {
    params,
  });
  return response.data;
};
